/* GBOF product-media and focus safeguard: isolated compatibility layer for Canopy product pages. */
(() => {
  const onProductPage = () => Boolean(document.querySelector('.product-main'));
  const isMobile = () => window.matchMedia('(max-width: 749px)').matches;
  const usable = (url) => Boolean(url && !url.startsWith('data:image'));

  const focus = () => {
    if (onProductPage()) document.documentElement.classList.add('gbof-product-focus');
  };

  const hydrateImage = (image) => {
    const source = image.dataset.src || image.getAttribute('data-original-src') || image.getAttribute('src') || '';
    const current = image.currentSrc || image.getAttribute('src') || '';
    if (!usable(source)) return;
    image.setAttribute('loading', 'eager');
    image.setAttribute('fetchpriority', 'high');
    if (!usable(current)) image.setAttribute('src', source);
    if (image.dataset.srcset) image.setAttribute('srcset', image.dataset.srcset);
    const preloader = new Image();
    preloader.onload = () => {
      if (!image.naturalWidth || !usable(image.currentSrc || '')) image.setAttribute('src', source);
    };
    preloader.src = source;
  };

  const hydrate = () => {
    if (!onProductPage() || !isMobile()) return;
    document.querySelectorAll('.product-media .media-viewer__item img.product-image').forEach(hydrateImage);
  };

  const run = () => { focus(); hydrate(); };
  /* GBOF immediate gallery hydration v1 */
  run();
  if (document.readyState !== 'loading') [350, 1200, 3000].forEach(delay => window.setTimeout(run, delay));
  document.addEventListener('DOMContentLoaded', () => {
    run();
    [350, 1200, 3000].forEach(delay => window.setTimeout(run, delay));
  });
  window.addEventListener('load', run, { once: true });
  document.addEventListener('change', (event) => {
    if (event.target.closest('.product-form, variant-picker')) window.setTimeout(run, 0);
  });
  document.addEventListener('shopify:section:load', run);
})();
